import {
  addCurrentAuthHeader,
  type SessionService,
} from '@efdigital/ll-addon-auth';

export type CustomLoginFlags = '' | 'IgnoreSSO' | 'NoSetPassword';

export type ManagementUserClient = {
  id: string;
  title: string;
};

export type ManagementUser = {
  id: string;
  user: {
    id: string;
  };
  encryptedIds: string[];
  email: string;
  expiryType: string;
  expires?: string;
  expiresAfter?: number;
  ignoreExpire: boolean;
  client: ManagementUserClient;
  rights: string[];
  excludeFromAnalytics: boolean;
  deleted: boolean;
  loginCount: number;
  lastLogin?: string;
  created: string;
  customLoginFlags: CustomLoginFlags;
  coaching: boolean;
};

export async function buildFindUserRequest(
  key: string,
  session: SessionService
): Promise<Request> {
  const init = await addCurrentAuthHeader(
    {
      method: 'GET',
    },
    { session }
  );

  return new Request(
    `${session.apis.monolithApi.host}/management-api/user/${encodeURIComponent(key)}`,
    init
  );
}

export async function parseFindUserResponse(
  response: Response
): Promise<ManagementUser> {
  if (!response.ok) {
    throw new Error(`Failed to find user: ${response.statusText}`);
  }

  return (await response.json()) as ManagementUser;
}
